// extracted by mini-css-extract-plugin
export default {"container":"QM-z","leftColumn":"RM-z","rightColumn":"SM-z","item":"TM-z"};